const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

const normalizeCountry = (country = {}) => ({
  key: String(country.key || '').trim(),
  label: String(country.label || '').trim()
});

const normalizeItem = (item = {}) => {
  const ticker = String(item.ticker || '').trim().toUpperCase();
  const listingDate = String(item.listing_date || '').trim();
  const phase = item.phase === 'upcoming' || item.phase === 'recent' ? item.phase : '';
  const country = normalizeCountry(item.country);

  if (!ticker || !ISO_DATE.test(listingDate) || !phase || !country.key || !country.label) {
    return null;
  }

  return {
    id: String(item.id || ticker),
    ticker,
    companyName: String(item.company_name || '').trim(),
    listingDate,
    phase,
    country,
    isTrading: Boolean(item.is_trading)
  };
};

const normalizeCountryOptions = (options = []) => {
  const seen = new Set();
  const normalized = (Array.isArray(options) ? options : [])
    .map(normalizeCountry)
    .filter(option => option.key && option.label && !seen.has(option.key) && seen.add(option.key));

  return normalized.some(option => option.key === 'all')
    ? normalized
    : [{ key: 'all', label: 'Todos los países permitidos' }, ...normalized];
};

export function normalizeUpcomingIposResponse(payload = {}) {
  const items = (Array.isArray(payload.data) ? payload.data : [])
    .map(normalizeItem)
    .filter(Boolean);
  const meta = payload.meta && typeof payload.meta === 'object' ? payload.meta : {};
  const ranges = meta.ranges && typeof meta.ranges === 'object' ? meta.ranges : {};
  const filters = meta.filters && typeof meta.filters === 'object' ? meta.filters : {};

  return {
    items,
    meta: {
      counts: {
        total: items.length,
        upcoming: items.filter(item => item.phase === 'upcoming').length,
        recent: items.filter(item => item.phase === 'recent').length
      },
      ranges: {
        upcomingFrom: String(ranges.upcoming_from || ''),
        upcomingUntil: String(ranges.upcoming_until || ''),
        recentSince: String(ranges.recent_since || '')
      },
      countryOptions: normalizeCountryOptions(meta.country_options),
      filters: {
        query: String(filters.q || ''),
        country: String(filters.country || 'all')
      }
    }
  };
}
